export const styles = theme => ({
  bold: { fontWeight: 'bold' },
  uppercase: { textTransform: 'uppercase' },
  underline: { textDecoration: 'underline' },
});
